import { render, staticRenderFns } from "./PerManagement.vue?vue&type=template&id=cd8aa67a&scoped=true"
import script from "./PerManagement.vue?vue&type=script&lang=js"
export * from "./PerManagement.vue?vue&type=script&lang=js"
import style0 from "./PerManagement.vue?vue&type=style&index=0&id=cd8aa67a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8aa67a",
  null
  
)

export default component.exports